import { useParams } from 'react-router-dom';

/** Current workspace org id from ``/org/:orgId/…``. */
export function useOrgId(): string {
  const { orgId } = useParams<{ orgId: string }>();
  if (!orgId) {
    throw new Error('Missing orgId route param');
  }
  return orgId;
}
